import classNames from "classnames";
import "./DashboardKPICard.scss";

interface DashboardKPICardProps {
  value: any;
  format?: (value: any) => string;
  title?: string;
  subTitle?: string;
}
const DashboardKPICard = (props: DashboardKPICardProps) => {
  return (
    <div className={classNames(`dashboard-kpi-card`)}>
      <div className="kpi-value">
        {props.format ? props.format(props.value) : props.value}
      </div>
      {props.title && <div className={`kpi-title`}>{props.title}</div>}
      {props.subTitle && <div className={`kpi-subtitle`}>{props.subTitle}</div>}
    </div>
  );
};

export default DashboardKPICard;
